var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgExcel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Excel_svg__clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.07 10.366L5.58 8.729v12.093c0 .553.458 1 1.023 1h16.373c.565 0 1.023-.447 1.023-1v-4.455l-8.93-6.001z",
    fill: "#185C37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.07 0H6.603C6.04 0 5.581.448 5.581 1v4.455l9.488 5.456 5.024 1.637L24 10.91V5.456L15.07 0z",
    fill: "#21A366"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.581 5.456h9.488v5.455H5.581V5.456z",
    fill: "#107C41"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M12.372 4.364h-6.79v13.64h6.79a1.015 1.015 0 001.023-1V5.363a1.015 1.015 0 00-1.023-1z",
    fill: "#80B485"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M11.814 4.91H5.58v13.639h6.233a1.015 1.015 0 001.023-1V5.909a1.015 1.015 0 00-1.023-1z",
    fill: "#80B485"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M11.814 4.91H5.58v12.548h6.233a1.015 1.015 0 001.023-1V5.91a1.015 1.015 0 00-1.023-1z",
    fill: "#80B485"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M11.256 4.91H5.58v12.548h5.675a1.015 1.015 0 001.023-1V5.91a1.015 1.015 0 00-1.023-1z",
    fill: "#80B485"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.023 4.91h10.233c.565 0 1.023.448 1.023 1v10.002c0 .552-.458 1-1.023 1H1.023a1.012 1.012 0 01-1.023-1V5.91c0-.552.458-1 1.023-1z",
    fill: "url(#Excel_svg__paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.169 14.161l2.152-3.26L3.35 7.66h1.586l1.077 2.073c.099.197.167.343.204.44h.014c.07-.158.145-.31.223-.458l1.15-2.054H9.06l-2.023 3.222 2.074 3.278H7.56L6.32 11.886a1.888 1.888 0 01-.149-.304h-.018a1.424 1.424 0 01-.144.294l-1.28 2.285H3.169z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.977 0H15.07v5.455H24V1c0-.552-.457-1-1.023-1z",
    fill: "#33C481"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.07 10.911H24v5.456h-8.93V10.91z",
    fill: "#107C41"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Excel_svg__paint0_linear",
    x1: 2.133,
    y1: 4.129,
    x2: 9.875,
    y2: 17.846,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18884F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#117E43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B6631"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Excel_svg__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v21.822H0z"
  })))));
}

export default __webpack_public_path__ + "8566ab6575daa6b430b6c15e98da4893.svg";
export { SvgExcel as ReactComponent };